/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

// Utils
import { isEmpty } from 'lodash';

/**
 * This form component is specific for legal documents.
 * It is used during the workspace creation and in the settings screen.
 *
 * It has all `BaseSelect` options, plus:
 *
 * @vue-prop {String} orgName the name of the organization
 *
 * @example
 *
 * legal-picker(
 *  :org-name="form.organization.name"
 *  :label="t('legal_documents')"
 *  :placeholder="t('legal_documents_placeholder')"
 *  name="legal_documents"
 *  v-model="form.legal_documents"
 *  validations="required"
 *  :focused="focus == 'legal_documents'")
 *      ...
 *
 * @category ui.components.form-elements.pickers
 * @exports LegalPicker
 */
const __vue_script__ = {
    name: 'LegalPicker',

    extends: BaseSelect,

    inheritAttrs: false,

    props: {
        value: {
            type: Array,
            default: null
        },

        orgName: {
            type: String,
            default: null
        },

        eventId: {
            type: String,
            default: null
        },

        disabled: {
            type: Boolean,
            default: null
        },

        emitInitial: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            legalDocumentManagerPath: null,
            documents: [],
            legalInnerValue: []
        };
    },

    computed: {
        /** @returns {boolean} */
        disable() {
            return this.disabled || !this.legalDocumentManagerPath;
        }
    },

    watch: {
        orgName: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.legalDocumentManagerPath = this.$services.legal.getOrgLegalDocumentManagerPath(value);
                    this.legalInnerValue = [];
                }
            }
        }
    },

    async created() {
        if (!isEmpty(this.value)) {
            await this.loadDocuments();
            this.legalInnerValue = this.documents.filter(doc => this.value.includes(doc._id));

            if (this.emitInitial) {
                // Updates the outer value (the model)
                this.$emit('input', this.legalInnerValue);
            }
        }
    },

    methods: {
        /**
         * Loads the legal documents for the specified organization.
         */
        async loadDocuments() {
            this.documents = await this.$services.legal.getLegalDocumentsForOrg(this.orgName, undefined, this.eventId);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"uid":_vm.uid,"errors":_vm.errors,"warning":_vm.warning,"dependant":_vm.dependant},scopedSlots:_vm._u([(_vm.legalDocumentManagerPath)?{key:"control-actions",fn:function(ref){return [(!_vm.disabled)?_c('a',{attrs:{"href":_vm.legalDocumentManagerPath,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('legal_picker.actions.create')))]):_vm._e()]}}:null],null,true)},[_c('multiselect',_vm._g(_vm._b({ref:"select",staticClass:"form-control",class:{'has-error': _vm.errors.length, 'has-warning': _vm.warning},attrs:{"options":_vm.documents,"id":_vm.uid,"multiple":"multiple","track-by":"_id","disabled":_vm.disable,"label":"title"},on:{"input":_vm.input,"open":_vm.loadDocuments},scopedSlots:_vm._u([{key:"caret",fn:function(toggle){return [_c('div',{staticClass:"toggler"},[_c('i',{staticClass:"ic-chevron-down"})])]}}]),model:{value:(_vm.legalInnerValue),callback:function ($$v) {_vm.legalInnerValue=$$v},expression:"legalInnerValue"}},'multiselect',_vm.attrs,false),_vm.listeners))],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LegalPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__